import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import "./ErrorMessage.scss";

const ErrorMessage = ({
  message,
  template = undefined,
  onClose,
  className,
}) => {
  const timeoutIdRef = useRef(null);
  const { t } = useTranslation();

  const onCloseError = useCallback(() => {
    clearTimeout(timeoutIdRef.current);

    if (onClose) {
      onClose();
    }
  }, [timeoutIdRef, onClose]);

  useEffect(() => {
    clearTimeout(timeoutIdRef.current);

    if (message) {
      timeoutIdRef.current = setTimeout(onCloseError, 3000);
    }
    return () => {
      clearTimeout(timeoutIdRef.current);
    };
  }, [message, onCloseError]);

  if (!message) {
    return null;
  }

  let messages;
  try {
    messages = JSON.parse(message);
  } catch (error) {
    messages = message
      ? [
          {
            msg: message,
          },
        ]
      : [];
    console.log('Message is invalid', error)
  }

  return messages.length > 0 ? (
    <div className={classNames("error-message", className)}>
      <div className="error-message-container">
        {messages.map((m) => {
          return (
            <div key={m.msg}>
              {template ? t(template, { message: t(m.msg) }) : m.msg}
            </div>
          );
        })}
      </div>
      {onClose && (
        <span onClick={() => onCloseError()} className="close">
          &#10005;
        </span>
      )}
    </div>
  ) : null;
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  template: PropTypes.string,
};

export default ErrorMessage;
